import { useTranslation } from 'react-i18next';

const PRESETS = [
    { id: '4w', labelKey: 'gym.bulkEnrollment.courses.preset4w' },
    { id: '3m', labelKey: 'gym.bulkEnrollment.courses.preset3m' },
    { id: '6m', labelKey: 'gym.bulkEnrollment.courses.preset6m' },
];

export default function EnrollmentPeriodBar({
    preset,
    from,
    to,
    today,
    onPreset,
    onFromChange,
    onToChange,
}) {
    const { t } = useTranslation();

    return (
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3 dark:border-gray-800 dark:bg-gray-800/60">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
                <div className="min-w-0">
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-50">
                        {t('gym.bulkEnrollment.courses.periodLabel')}
                    </p>
                    <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
                        {t('gym.bulkEnrollment.courses.periodHint')}
                    </p>
                </div>
                <div className="flex flex-wrap gap-2">
                    {PRESETS.map((item) => {
                        const active = preset === item.id;
                        return (
                            <button
                                key={item.id}
                                type="button"
                                aria-pressed={active}
                                onClick={() => onPreset(item.id)}
                                className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
                                    active
                                        ? 'bg-indigo-600 text-white'
                                        : 'bg-white text-gray-700 ring-1 ring-gray-200 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:ring-gray-700 dark:hover:bg-gray-700'
                                }`}
                            >
                                {t(item.labelKey)}
                            </button>
                        );
                    })}
                </div>
            </div>
            <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
                <label className="block text-xs font-medium text-gray-600 dark:text-gray-300">
                    {t('gym.bulkEnrollment.courses.periodFrom')}
                    <input
                        type="date"
                        value={from}
                        min={today}
                        onChange={(event) => onFromChange(event.target.value)}
                        className="mt-1 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
                    />
                </label>
                <label className="block text-xs font-medium text-gray-600 dark:text-gray-300">
                    {t('gym.bulkEnrollment.courses.periodTo')}
                    <input
                        type="date"
                        value={to}
                        min={from || today}
                        onChange={(event) => onToChange(event.target.value)}
                        className="mt-1 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
                    />
                </label>
            </div>
        </div>
    );
}
